import { ActionContext } from 'vuex';

import { ActionClass, UserState } from '../../../models';

import { CONFIG_CONSTS } from '../../../store/config/config.consts';

export class ClearModuleAction implements ActionClass {

  public static execute({ commit }: ActionContext<UserState, any>): void {
    commit(CONFIG_CONSTS.mutations.clearModule);
  }

}
